import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import {
    FundingDetailReportComponent,
    TableContainer,
    Title,
    OpenExtra,
    FooterButton,
    Attach
} from "./UserFundingDetailReport.styles";
import { RoundedRowContainer, GeneralButton } from "../CommonLayout";
import FundingApplicationUserActions from "../../../actions/FundingApplicationsUser";
import Loading from "../../Layout/CommonLayoutPart/Loading";
import { ColorName } from "../../Variables";

const UserFundingDetailReport = (props) => {
    const { t } = useTranslation();
    const fileInput = useRef(null);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [classNameStatus, setClassNameStatus] = useState('');
    const [nameFileAttach, setNameFileAttach] = useState('');
    const [fileAttach, setFileAttach] = useState('');
    const [clnOpenExtra, setClnOpenExtra] = useState('d-none');
    const [submitData, setSubmitData] = useState('');
    const [idItemReportStatus, setIdItemReportStatus] = useState();
    const [dataUrl, setDataUrl] = useState();
    const [idApplicationItem, setIdApplicationItem] = useState();
    const FundingStorage = useSelector((state) => state.FundingApplicationsUser);

    useEffect(() => {
        setDescription(props.description);
        setStatus(props.status);
        setDueDate(props.dueDate);
        setClassNameStatus(props.classNameStatus);
        setIdItemReportStatus(props.idItemReportStatus);
        setSubmitData(props.submitData);
        setDataUrl(props.dataUrl);
        setIdApplicationItem(props.idApplicationItem);
    }, [props]);

    const textareaSubmitData = (e) => {
        setSubmitData(e.target.value);
    };

    useEffect(() => {
        setIsLoading(FundingStorage.isLoading);
    }, [FundingStorage]);

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setNameFileAttach(e.target.files[0].name);
            setFileAttach(e.target.files[0]);
        }
    };

    const updateReportStatus = (id) => {
        const applyApplicationId = {
            apply_application_id: idApplicationItem
        };
        const formData = new FormData();
        formData.append('submitted_data', submitData);
        formData.append('status', 2);
        formData.append('apply_application_id', idApplicationItem);
        formData.append('file_attach', fileAttach);
        dispatch(FundingApplicationUserActions.updateReportStatusRequest(id, formData, applyApplicationId));
    };

    const textDescription = () => {
        return (
            <div>
                <span>
                    Your progress report is due. Please submit the following information.
                </span>
                <br />
                <span>
                    1) Your financial report
                </span>
                <br />
                <span>
                    2) Your budgeting report
                </span>
                <br />
                <span>
                    3) Your progress report.
                </span>
                <br />
                <span>
                    You must submit the information requested by attaching documents and the only attachment formats accepted are: pdf, excel, word. Any other formats will not be accepted.
                </span>
            </div>
        );
    };

    const _renderReportByStatus = (title, className) => {
        return (
            <RoundedRowContainer direction='column'>
                <TableContainer>
                    <thead>
                        <tr>
                            <td>
                                {description}
                                {' '}
                                <div className="text-description">{textDescription()}</div>
                            </td>
                            <td className={classNameStatus}>{status}</td>
                            <td>{dueDate}</td>
                            <td>
                                <GeneralButton
                                    type="button"
                                    background={ColorName.chathamsBlueDark}
                                    defaultValue={title}
                                    height='35px'
                                    onClick={() => setClnOpenExtra('d-block')}
                                />
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="description" />
                            <td className="status" />
                            <td className="due-date" />
                            <td className="button" />
                        </tr>
                    </tbody>
                </TableContainer>
                <OpenExtra className={className}>
                    <Attach>
                        <i
                            className="fas fa-paperclip attach"
                            onClick={() => fileInput.current.click()}
                        />
                        <div className="text-attach">
                            <div>{nameFileAttach === '' ? dataUrl : nameFileAttach}</div>
                            <div>
                                {t("general.Please attach all supporting documents here")}
                                {' '}
                                <br />
                                {t("general.You can use the comment box below  for any additional information")}
                            </div>
                        </div>
                        <input
                            ref={fileInput}
                            type="file"
                            className='d-none'
                            onChange={(e) => handleFileChange(e)}
                        />
                    </Attach>
                    <textarea className="textarea" onChange={textareaSubmitData} value={_.isEmpty(submitData) ? '' : submitData} />
                    <FooterButton>
                        <GeneralButton
                            type="button"
                            background={ColorName.chathamsBlueDark}
                            defaultValue={t("general.Cancel")}
                            onClick={() => setClnOpenExtra('d-none')}
                            className="space-button"
                        />
                        <GeneralButton
                            type="button"
                            background={ColorName.chathamsBlueDark}
                            defaultValue={t("general.Submit")}
                            onClick={() => updateReportStatus(idItemReportStatus)}
                        />
                    </FooterButton>
                </OpenExtra>
            </RoundedRowContainer>
        );
    };

    return (
        <FundingDetailReportComponent>
            {isLoading && <Loading />}
            <Title>
                <div className="description">
                    <div className="text-description">{t("general.Description")}</div>
                </div>
                <div className="status">{t("general.Status")}</div>
                <div className="due-date">{t("general.Due Date")}</div>
                <div className="button" />
            </Title>
            {status === "DUE" && _renderReportByStatus('Open', clnOpenExtra)}
            {status === "SUBMITTED" && _renderReportByStatus('View', clnOpenExtra)}
        </FundingDetailReportComponent>
    );
};

UserFundingDetailReport.propTypes = {
    idApplicationItem: PropTypes.number,
    idItemReportStatus: PropTypes.number,
    submitData: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.string,
    dueDate: PropTypes.string,
    classNameStatus: PropTypes.string,
    dataUrl: PropTypes.string
};

export default UserFundingDetailReport;
